<template>
  <fieldset>
    <legend id="ai-tags-title" class="body-1-bold mb-12">
      {{ i18n(translations.title) }}
    </legend>

    <div class="flex flex-wrap gap-8">
      <ul id="aiTagsList" class="contents">
        <li
          v-for="(tag, index) in tagsList"
          :key="tag.id"
          :class="{ hidden: index >= MAX_TAGS && collapsedTags }"
        >
          <Chip
            v-model="selectedTags"
            :count="tag.count"
            :icon="tag.icon"
            :label="tag.label"
            :value="tag.id"
            :variant="tag.sentiment"
          />
        </li>
      </ul>
      <RevLink
        v-if="canDisplayMoreTags"
        :id="toggleButtonId"
        aria-controls="aiTagsList"
        :aria-expanded="!collapsedTags"
        :aria-labelledby="`${toggleButtonId} ai-tags-title`"
        :underlined="false"
        @click="collapsedTags = !collapsedTags"
      >
        {{
          collapsedTags
            ? i18n(translations.showMore)
            : i18n(translations.showLess)
        }}
      </RevLink>
    </div>
  </fieldset>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'

import type { ReviewsTagDetails } from '@backmarket/nuxt-layer-reviews/api/reviews/types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'

import translations from './AITags.translations'
import Chip from './Chip.vue'
import { formatRawTag, sentimentToIcon, tagToLabel } from './helpers'

const i18n = useI18n()

const { tags } = defineProps<{
  tags: ReviewsTagDetails[]
}>()

const MAX_TAGS = 6
const canDisplayMoreTags = tags.length > MAX_TAGS
const selectedTags = ref([])

const collapsedTags = ref(canDisplayMoreTags)
const toggleButtonId = computed(() =>
  collapsedTags.value ? 'ai-tags-show-more' : 'ai-tags-show-less',
)

const tagsList = computed(() => {
  return tags.map(({ tag, mentionCount, sentiment }) => ({
    id: tag,
    label: i18n(tagToLabel[tag]) ?? formatRawTag(tag),
    count: mentionCount,
    icon: sentimentToIcon[sentiment],
    sentiment,
  }))
})
</script>
